import { rbsDataMapper } from '../mappers/rbs-data.mapper';
import { Learner } from '../models/learner';
import { RbsData } from '../models/rbs-data';
import { appUrlsConfig } from './app-urls.config';
import { axiosService } from './axios.service';

/**
 * Update RBS information.
 * @param {RbsData} rbsData RBS data.
 * @param {Learner["id"]} learnerId Learner ID.
 * @returns {Promise<void>}
 */
async function updateRbsInformation(rbsData, learnerId) {
  const rbsDataDto = rbsDataMapper.toDto(rbsData);
  await axiosService.put(appUrlsConfig.learner.rbs(learnerId), rbsDataDto);
}

/**
 * Verify RBS information.
 * @param {RbsData} rbsData RBS data.
 * @returns {Promise<void>}
 */
async function verifyRbsInformation(rbsData) {
  const rbsDataDto = rbsDataMapper.toDto(rbsData);
  await axiosService.get(appUrlsConfig.rbs.verify, { params: rbsDataDto });
}

export const rbsService = {
  updateRbsInformation,
  verifyRbsInformation,
};
